import { z } from 'zod/v4';

import { applicationRoleSchema } from './application-role.schema';

export const accountApplicationRoleSchema = z.object({
  product: z.object({
    id: z.number().min(1),
    name: z.string().min(1),
    displayName: z.string().min(1),
  }),
  roles: z.array(applicationRoleSchema),
});

export type AccountApplicationRole = z.infer<
  typeof accountApplicationRoleSchema
>;
